var __jsx = React.createElement;
import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLightbulb } from '@fortawesome/free-solid-svg-icons';
import styles from '../../styles/rca/rca.module.scss';

var RCAFormNotice = function RCAFormNotice() {
  return __jsx("div", {
    className: "".concat(styles.boxWrapper, " ").concat(styles.bgGreen, " mb-5 text-left")
  }, __jsx("p", {
    className: "".concat(styles.boxCategory)
  }, __jsx(FontAwesomeIcon, {
    icon: faLightbulb,
    height: 16,
    width: 16,
    className: "mr-2 green"
  }), "Completeaz\u0103 corect formularul"), __jsx("p", {
    className: styles.info
  }, "Poli\u021Ba de asigurare va fi emis\u0103 \xEEn baza informa\u021Biilor completate. Daca datele nu sunt corecte, poli\u021Ba ar putea fi anulat\u0103 sau ai putea suporta costuri suplimentare."));
};

export default RCAFormNotice;